import { store } from 'Store/store.index';
import toolbar from './collaborationToolbar.art'

export default function ShowHideCommonToolbarController(UIExtension) {
  UIExtension.modular.module('phantom').controller('ShowHideCommonToolbarController', {
    showOtherToolbar() {
      this.pdfUI.getRootComponent()
        .then(root => {
          this.otherComponent = root.getComponentByName('collaboration-toolbar');
          if (!this.otherComponent) {
            root.insert(toolbar(), 1);
            this.otherComponent = root.getComponentByName('collaboration-toolbar');
          }
          this.otherComponent.show();
          const groupUndoRedo = this.otherComponent.getComponentByName('collaboration-toolbar-group-undo-redo');
          const groupNightMode = this.otherComponent.getComponentByName('collaboration-toolbar-night-mode');
          ribbonBtnShownWithinTeams(groupUndoRedo);
          ribbonBtnShownWithinTeams(groupNightMode);
        });
    },
    mounted() {
      store.appStore.viewerEventEmitter.on('changeToolBar', (value) => {
        if (value === 'common') {
          console.log("no 分享")
          this.component.show();
          
          this.pdfUI.getRootComponent()
          .then(root => {
            this.otherComponent = root.getComponentByName('collaboration-toolbar');
            if (!this.otherComponent) {
              root.insert(toolbar(), 1);
              this.otherComponent = root.getComponentByName('collaboration-toolbar');
            }
            this.otherComponent.hide();
          });
        } else {
          console.log("分享2")
          this.component.hide();
          this.showOtherToolbar(true)
        }

      });
    },
  });
}

function ribbonBtnShownWithinTeams(btnNode) {
  if (!btnNode) return;
  if (store.teamsAppStore.inTeamsApp) {
    btnNode.show();
  } else {
    btnNode.hide();
  }
}
